import { isFeatureDev } from './feature-dev';

export const initUsercentrics = (usercentricsId: string, gtmId: string) => {
  if (isFeatureDev) {
    console.log({ usercentricsId, gtmId });
  }

  const script = document.createElement('script');
  script.id = 'usercentrics-cmp';
  script.src = 'https://web.cmp.usercentrics.eu/ui/loader.js';
  script.setAttribute('data-settings-id', usercentricsId);

  document.head.appendChild(script);

  const scriptGTM = document.createElement('script');
  scriptGTM.type = 'text/plain';
  scriptGTM.setAttribute('data-usercentrics', 'Google Tag Manager');
  scriptGTM.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');
    `;
  document.head.appendChild(scriptGTM);

  const noscriptGTM = document.createElement('noscript');
  noscriptGTM.innerHTML = `
    <noscript type="text/plain" data-usercentrics="Google Tag Manager><iframe src=https://www.googletagmanager.com/ns.html?id=${gtmId}
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;
  document.body.appendChild(noscriptGTM);
};

export const trackCustomEvent = (
  eventName: string,
  eventData: Record<string, unknown> = {},
) => {
  if (
    typeof window === 'undefined' ||
    !('dataLayer' in window) ||
    !window.dataLayer ||
    !Array.isArray(window.dataLayer)
  ) {
    console.warn('DataLayer is not available for tracking events');
    return;
  }
  window.dataLayer.push({
    event: eventName,
    ...eventData,
  });
};

export const trackSearchEvent = (
  searchTerm: string,
  resultCount?: number,
  category?: string,
) => {
  trackCustomEvent('search', {
    search_term: searchTerm,
    search_category: category,
    search_results_count: resultCount,
  });
};
